import { ThemeProvider } from 'next-themes';

export function ColorModeProvider(props: Parameters<typeof ThemeProvider>[0]) {
  return (
    <ThemeProvider
      attribute="class"
      disableTransitionOnChange
      defaultTheme="light"
      enableSystem={false}
      {...props}
    />
  );
}
